export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/exam/createdistrict',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allDistricts'],
    })
